// extracted by css-extract-rspack-plugin
export default {"DashCardVisualization":"Q0_wa","VirtualDashCardOverlayText":"drjtH","InlineParametersList":"PmTA3","InlineParametersMenuTrigger":"QFmyA"};